import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useSessionEntity from '../../../hooks/useSessionEntity';
import { getRoute, loading } from '../../../actions/sessions';

export default function RechargeIntro() {
  const dispatch = useDispatch();
  const history = useHistory();
  const merchant = useSessionEntity('merchant');
  const isLoading = useSelector(state => state.sessions.get('loading'));

  const styles = {
    borderTop: {
      borderTop: '1px solid #E9EDF2'
    },
    borderTopBottom: {
      borderTop: '1px solid #E9EDF2',
      borderBottom: '1px solid #E9EDF2'
    },
    roundedBorder: {
      border: '1px solid #E9EDF2',
      borderRadius: '50%',
      padding: '0.5em'
    }
  };

  const next = (userType) => {
    if (userType === 'new') {
      dispatch(loading(true));
      dispatch(getRoute())
        .finally(() => dispatch(loading(false)));
    } else {
      history.push("/init/existing_user")}
  }

  useEffect(() => {
    dispatch(loading(false));
  }, []);

  return (
    <div id="content">
      <p className="ck-blue is-size-4 has-text-centered">
        <FontAwesomeIcon icon={['fal', 'repeat']} border  style={styles.roundedBorder} />
      </p>
      <div className="title is-size-4 has-text-centered">Welcome to Credit Key <span className="ck-blue">Recharge</span></div>

      <div className="columns">
        <div className="column is-centered has-text-centered">
          <p className="mb-2">Let's get you set up for repeat {merchant.name} purchases<br />
            with Credit Key. It takes less than 5 minutes.</p>
        </div>
      </div>

      <div className="columns">
        <div className="column is-centered">
          <div className="level is-mobile p-3 mb-0" style={styles.borderTop}>
            <div className="level-left">
              <div className="level-item">
                <span className="fa-layers fa-fw is-size-4 has-text-grey">
                  <FontAwesomeIcon icon={'bags-shopping'} />
                </span>
              </div>
              <div className="level-item">
                <ul>
                  <li>{merchant.name} sales reps can place</li>
                  <li> replenishment orders on your behalf.</li>
                </ul>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item has-text-grey-light">
                <FontAwesomeIcon icon={['fal', 'info-circle']} />
              </div>
            </div>
          </div>

          <div className="level is-mobile p-3 mb-0" style={styles.borderTop}>
            <div className="level-left">
              <div className="level-item">
                <span className="fa-layers fa-fw is-size-4 has-text-grey">
                  <FontAwesomeIcon icon={'circle-calendar'} />
                </span>
              </div>
              <div className="level-item">
                <ul>
                  <li>Pre-select terms from</li>
                  <li>Net 30 up to 6 months or longer.</li>
                </ul>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item has-text-grey-light">
                <FontAwesomeIcon icon={['fal', 'info-circle']} />
              </div>
            </div>
          </div>

          <div className="level is-mobile p-3 mb-0" style={styles.borderTopBottom}>
            <div className="level-left">
              <div className="level-item">
                <span className="fa-layers fa-fw is-size-4 has-text-grey">
                  <FontAwesomeIcon icon={'circle-dollar'} />
                </span>
              </div>
              <div className="level-item">
                <ul>
                  <li>Pay early with no fee.</li>
                  <li>Change your default terms at any time.</li>
                </ul>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item has-text-grey-light">
                <FontAwesomeIcon icon={['fal', 'info-circle']} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="columns">
        <div className="column is-centered">
          <button
            type="submit"
            role="submit"
            disabled={isLoading}
            className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold', {
              'is-loading': isLoading
            })}
            onClick={() => next('new')}>
            I'm new to Credit Key
          </button>
        </div>
      </div>

      <div className="columns">
        <div className="column is-centered">
          <button
            type="submit"
            role="submit"
            disabled={isLoading}
            className={'button is-primary is-large is-fullwidth is-outlined has-text-weight-bold'}
            onClick={() => next('existing')}>
            I already have a Credit Key account
          </button>
        </div>
      </div>
    </div>
  );
}
